// Generated by nuxt-echarts

import { use } from 'echarts/core'
import {
  CanvasRenderer,
} from 'echarts/renderers'
import {
  LineChart,
} from 'echarts/charts'
import {
  DatasetComponent,
  GridComponent,
  TooltipComponent,
} from 'echarts/components'
import {

} from 'echarts/features'

use([
  CanvasRenderer,
  LineChart,
  DatasetComponent,
  GridComponent,
  TooltipComponent,

])